import React, { useState } from 'react';
import { ProfileDropdown } from '../components/profileDropdown/ProfileDropdown/ProfileDropdown';
import { SettingsDropdown } from '../components/settingsDropdown/SettingsDropdown';
import { FirmSelectorModal } from '../components/firmDropdown/FirmSelectorModal/FirmSelectorModal';
import * as S from '../Header.styles';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { WechatOutlined, BankOutlined } from '@ant-design/icons';

interface DesktopHeaderProps {
  isTwoColumnsLayout: boolean;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ isTwoColumnsLayout }) => {
  const [isFirmModalOpen, setFirmModalOpen] = useState(false);

  const leftSide = isTwoColumnsLayout ? (
    <S.SearchColumn xl={16} xxl={17}>
      <BaseRow justify="space-between">
        <BaseCol xl={15} xxl={12}>
          {/* <HeaderSearch /> */}
        </BaseCol>
        <BaseCol>{/* <S.GHButton /> */}</BaseCol>
      </BaseRow>
    </S.SearchColumn>
  ) : (
    <>
      <BaseCol lg={10} xxl={8}>
        {/* <HeaderSearch /> */}
      </BaseCol>
      <BaseCol>{/* <S.GHButton /> */}</BaseCol>
    </>
  );

  return (
    <BaseRow justify="space-between" align="middle">
      {leftSide}

      <S.ProfileColumn xl={8} xxl={7} $isTwoColumnsLayout={isTwoColumnsLayout}>
        <BaseRow align="middle" justify="end" gutter={[5, 5]}>
          <BaseCol>
            <BaseRow gutter={[{ xxl: 5 }, { xxl: 5 }]}>
              <BaseCol>
                <S.HeaderActionWrapper onClick={() => setFirmModalOpen(true)}>
                  <BaseButton type={'text'} icon={<BankOutlined />} />
                  {/*  */}
                </S.HeaderActionWrapper>
              </BaseCol>
              <BaseCol style={{ display: 'none' }}>
                <S.HeaderActionWrapper>
                  <BaseButton type={true ? 'text' : 'ghost'} icon={<WechatOutlined />} />
                </S.HeaderActionWrapper>
              </BaseCol>
              {/* <BaseCol>
                <NotificationsDropdown />
              </BaseCol> */}
              <BaseCol>
                <SettingsDropdown />
              </BaseCol>
            </BaseRow>
          </BaseCol>
          <BaseCol>
            <ProfileDropdown />
          </BaseCol>
        </BaseRow>
      </S.ProfileColumn>
      <FirmSelectorModal isOpen={isFirmModalOpen} onClose={() => setFirmModalOpen(false)} />
    </BaseRow>
  );
};
